import React from 'react';

const CallToAction = () => {
  return (
    <section className="py-16 bg-deep-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold font-montserrat mb-4">READY TO WORK WITH US?</h2>
        <p className="text-xl mb-8 max-w-3xl mx-auto">
          Contact our team to discuss your automotive electronics assembly and distribution needs
        </p>
        <a
          href="/contact"
          className="inline-block bg-light-blue hover:bg-blue-700 text-white font-montserrat font-semibold uppercase tracking-wider py-3 px-8 border border-transparent rounded-md shadow-md transition duration-300"
        >
          CONTACT US
        </a>
      </div>
    </section>
  );
};

export default CallToAction;
